import apiClient from './apiClient';

export interface QueryParams {
  docFrom?: string;
  docTo?: string;
}

export interface DocumentRow {
  FL040_01: string;  // 文件編號
  FL040_11: string;  // 文件名稱
  FL040_12: string;  // 發行日期
  FL040_13: string;  // 文件生效日期
  FL040_14: string;  // 文件類別代碼
  FL040_15: number;  // 版次
  FL040_16: number;  // 份數
  FL040_17: string;  // 關聯索引鍵
  FL040_79: boolean; // 作廢旗標
  FL040_80: string;  // 文件狀態碼
  FL040_81: string;  // 建立人員
  FL040_82: string;  // 建立日期
  FL040_83: string;  // 核准人員
  FL040_84: string;  // 核准日期
  FL040_93: string;  // 稽核人員
  FL050_11: string;  // 附件/明細名稱
  FL050_12: string;  // 附件/明細內容
}

export interface QueryResponse {
  data: DocumentRow[];
  count: number;
  message?: string;
}

export const pwl304Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pwl304/query', params);
    return res.data;
  },
};
